/* eslint-disable max-len */
import { IconProps } from 'models/icons';
import React from 'react';

const DisconnectIcon: React.FC<IconProps> = ({ color, ...props }) => (
  <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M6.32076 2.32002V0.720001M11.1208 15.1201V16.7202M2.32072 6.32005H0.720703M15.1208 11.1201H16.7209M3.05209 3.05139L1.92071 1.92001M14.3895 14.3888L15.5208 15.5201M8.72078 13.2456L7.02371 14.9427C5.77402 16.1924 3.74787 16.1924 2.49818 14.9427C1.24849 13.693 1.24849 11.6668 2.49818 10.4171L4.19526 8.72008M13.2463 8.72008L14.9434 7.02301C16.1931 5.77331 16.1931 3.74717 14.9434 2.49748C13.6937 1.24779 11.6675 1.24779 10.4178 2.49748L8.72078 4.19455"
      stroke="#141414"
      strokeWidth="1.44001"
      strokeLinecap="round"
      strokeLinejoin="round"
      fill={color ?? props?.style?.color}
    />
  </svg>
);

export default DisconnectIcon;
